'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactBootstrap = require('react-bootstrap');

var _File = require('./File');

var _File2 = _interopRequireDefault(_File);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_reactBootstrap.FormControl.File = _File2.default;

var _default = _reactBootstrap.FormControl;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/components/FormControl/index.jsx');
}();

;